import { takeEvery, put } from 'redux-saga/effects';
import { consts as teamUserConsts } from './team-user';
import { consts as getTeamUserConsts } from '../profiles/get-team-user';

function* addTeamUserWorker(action) {
  yield put({
    type: teamUserConsts.ADD,
    payload: action.payload,
  });
}

export function* addTeamUserSaga() {
  yield takeEvery(getTeamUserConsts.SUCCEED, addTeamUserWorker);
}



// WEBPACK FOOTER //
// ./src/redux/context/team-user-saga.js